module.exports = __webpack_public_path__ + "assets/img/returnBtn-216992d1.png";